<template>
    <div class="tc-main-helper"
         @click="storeUI.setIsGuide(!storeUI.isGuide)">
        <SVGQuestion/>
        <div class="tc-main-helper-text">
            {{storeUI.isGuide ? text.true : text.false}}
        </div>
    </div>
</template>

<script>
import SVGQuestion from '@/UI/SVG/SVGQuestion.vue';
import { useStoreUI } from '@/Store/storeUI';

export default {
    name: 'LowerHelpersButton',
    components: { SVGQuestion },
    data() {
        return {
            text: {
                false: 'Показать подсказки',
                true: 'Скрыть подсказки',
            },
        };
    },
    setup() {
        const storeUI = useStoreUI();
        return {
            storeUI,
        };
    },
};
</script>

<style scoped lang="scss">
.tc-main-helper {
    display: flex;
    flex-direction: row;
    gap: 10px;
    color: #00458D;
    justify-content: center;
    align-items: center;
    width: max-content;
    height: max-content;
    cursor: pointer;
    user-select: none;
    pointer-events: all;
    z-index: 2001;
    //text-shadow: 1px 1px  #f2f2f2;
}

.tc-main-helper-text {
    font-size: 16px;
    font-weight: 600;
}
</style>
